module.exports = __webpack_public_path__ + "img/teaser_traktor3.f26ac1f5.jpg";